import { observer } from 'src/utils/mobx-react';
import React, { useEffect } from 'react';
import { YaspaIFrameStyled } from './YaspaSegment/YaspaSegment.style';
import { useCommon } from 'src/domains/common/Common';
import { z } from 'zod';

const iframeMessageZod = z.object({
    type: z.union([z.literal('success'), z.literal('failure'), z.literal('redirect')]),
    redirectUrl: z.string(),
});

const handleOnMessage = (message: string): void => {
    const validate = iframeMessageZod.safeParse(JSON.parse(message));
    if (validate.success === false) {
        return;
    }

    if (validate.data.type === 'redirect') {
        window.open(validate.data.redirectUrl, '_self');
    }
};

export interface MessageIframeYaspaDataType {
    eventType: 'onCloseHiddenIframeSuccess' | 'onCloseHiddenIframeFail';
}

export interface YaspaIframePropsType {
    src: string;
    onMessage: (data: MessageIframeYaspaDataType) => void;
    className?: string;
}

export const YaspaIframe = observer(
    'YaspaIframe',
    ({ src, onMessage, className }: YaspaIframePropsType): JSX.Element => {
        const common = useCommon();
        const onMessageHandler = (event: MessageEvent): void => {
            const { gatewayApiHost } = common.envVariables;
            if (gatewayApiHost === null) {
                return;
            }

            try {
                if (event.data.eventType !== undefined) onMessage({ eventType: event.data.eventType });
            } catch (error) {
                console.error('Failed to parse event data:', error);
            }
        };

        useEffect(() => {
            window.addEventListener('message', onMessageHandler);

            return () => {
                window.removeEventListener('message', onMessageHandler);
            };
        }, []);

        return (
            <YaspaIFrameStyled
                className={className}
                src={src}
                onMessage={handleOnMessage}
                title='yaspa-iframe'
                data-test='yaspa-iframe'
            />
        );
    }
);
